import { useContextState } from '../../../../../../../hooks/theme'
import { SxProps, Theme } from '@mui/system'

export const getQueryConfigStyles = () => {
  const { colors: color } = useContextState()

  const radioGroupRow: SxProps<Theme> = {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    alignItems: 'center',
  }

  const radioLabel: SxProps<Theme> = {
    m: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '13px',
      color: color.color13,
    },
  }

  const radioChecked: SxProps<Theme> = {
    border: `1px solid ${color.color45}`,
    borderRadius: '20px',
    pr: '10px',
    backgroundColor: 'transparent',
  }

  const companySelect: SxProps<Theme> = {
    minWidth: '300px',
    maxWidth: '320px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      fontSize: '13px',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      backgroundColor: color.color5,
      paddingRight: '4px',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -9px)',
    },
  }

  const listColumn: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    borderRadius: '2px',
    border: `1px solid ${color.color10}50`,
    height: '360px',
    overflow: 'hidden',
  }

  const listColumnHeader: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '14px',
    py: '6px',
    fontSize: '14px',
    fontWeight: 500,
    color: `${color.color10}`,
    backgroundColor: `${color.color10}18`,
    borderBottom: `1px solid ${color.color10}50`,
  }

  const listColumnCounter: SxProps<Theme> = {
    fontSize: '12px',
    fontWeight: 500,
    color: color.color45,
  }

  const searchField: SxProps<Theme> = {
    pb: '0px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      fontSize: '13px',
      height: '36px',
      backgroundColor: color.color5,
    },
    '& .MuiInputBase-root': {
      py: 0,
    },
  }

  const checkboxRow: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    border: `1px solid ${color.color10}50`,
    borderRadius: '4px',
    cursor: 'pointer',
    mb: '4px',
    '&:hover': {
      backgroundColor: `${color.color10}22`,
    },
    '& .MuiTypography-root': {
      fontSize: '13px',
      color: color.color13,
    },
  }

  const checkboxRowAll: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    marginBottom: '4px',
    border: `1px solid ${color.color10}50`,
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `${color.color10}22`,
    },
    '& .MuiTypography-root': {
      fontSize: '13px',
      color: color.color13,
    },
  }

  return {
    radioGroupRow,
    radioLabel,
    radioChecked,
    companySelect,
    listColumn,
    listColumnHeader,
    listColumnCounter,
    searchField,
    checkboxRow,
    checkboxRowAll,
  }
}
